var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-view-list-field',{attrs:{"is-condensed":_vm.isCondensed,"is-sticky":_vm.isSticky,"field":_vm.field,"filter":_vm.filter}},[(_vm.item.players.length)?_c('app-view-common-insight_play-players',{attrs:{"item":_vm.item,"inline":true}}):_vm._e(),(!_vm.item.players.length)?_c('span',[_vm._v("-")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }